// extracted by mini-css-extract-plugin
export default {"tarjetaContacto":"DatosGeneralesComponent_tarjetaContacto__hw3PT","circuloContacto":"DatosGeneralesComponent_circuloContacto__Z9KH9"};